module.exports = __webpack_public_path__ + "media/images/logos/courtsdesk-no-text-color-35x23-e34c7266efb04c32c879a2823799d945.svg";